import Axios from 'axios'
import template from 'url-template'
import * as _ from 'lodash'
// 超时设置
Axios.defaults.timeout = 20 * 60 * 1000
// 跨域是否带Token
Axios.defaults.withCredentials = true
//  Content-Type
const lang = localStorage.getItem('lang') || 'zh'
Axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers['Accept-Language'] = lang

// 导出已有默认配置的axios类
export default Axios

/** -----------  axios实例配置 -------------- */
// 接收axios实例
export const axiosInstance = (
	instance,
	[method, url],
	params,
	options = {}
) => {
	const requeseConf = {
		// `headers`是自定义的要被发送的头信息
		method: method || 'GET',
		// `url`是服务器链接，用来请求
		url: '',
		// `headers`是自定义的要被发送的头信息
		headers: {},
		// 请求连接中的请求参数，必须是一个纯对象，或者URLSearchParams对象
		params: params || null,
		// `data`是请求提需要设置的数据
		// 只适用于应用的'PUT','POST','PATCH'，请求方法
		// 当没有设置`transformRequest`时，必须是以下其中之一的类型（不可重复？）：
		// -string,plain object,ArrayBuffer,ArrayBufferView,URLSearchParams
		// -仅浏览器：FormData,File,Blob
		// -仅Node：Stream
		data: {},
		...options
		// responseType: options && options.responseType || "json",
		// // 是否需要获取所有的response
		// getAll: options && !!options.getAll
	}
	// 是否需要请求参数
	const paramsIntro = _.cloneDeep(params)
	if (_.isObject(params)) {
		// paramsIntro = _.omit(
		// paramsIntro,
		// Object.keys(params).filter(key => {
		// 获取url里已有的参数名称 或 null/undefined
		// return url.includes(key) || _.isNil(params[key])
		// })
		// )
		// paramsIntro = new URLSearchParams(paramsIntro)
		Object.keys(params).forEach(key => {
			const reg = new RegExp(`{${key}}`)
			// 获取url里已有的参数名称 或 null/undefined
			if (reg.test(url) || _.isNil(params[key])) {
				delete params[key]
			}
		})
		// paramsIntro = new URLSearchParams(paramsIntro)
	}
	requeseConf.url = template.parse(url).expand(params)
	if (method.toUpperCase() === 'GET') {
		requeseConf.params = params
	} else {
		let paramsIntro = ''
		for (const it in params) {
			paramsIntro +=
        encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&'
		}
		requeseConf.data = paramsIntro.slice(0, paramsIntro.length - 1)
	}
	requeseConf.data = paramsIntro
	// url-template

	// params转form
	// if (options && options.form) {
	//   requeseConf.header['Content-Type'] =
	//     'application/x-www-form-urlencoded'
	// requeseConf.params = paramsIntro
	//   requeseConf.data = qs.stringify(params)
	// }
	// 在header中加入本地loaclstorage的accessToken
	if (window.sessionStorage.getItem('accessToken')) {
		requeseConf.headers['accessToken'] = window.sessionStorage.getItem(
			'accessToken'
		)
	}
	// 发送请求
	return instance(requeseConf)
}
